import { createGlobalState } from './createGlobalState';

const { useState, useWithState } = createGlobalState<(() => Promise<void>) | null>((_, a) => a, null);

async function ignore<T>(p: () => Promise<T>) {
    await p();
}

export function useWithRevokeToken<T>(fn: (() => Promise<T>) | null) {
    return useWithState(() => fn ? () => ignore(fn) : null);
}

export {
    useState as useRevokeToken,
};
